import React, { useEffect, Fragment, useState, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { useRealtimeDrivers } from 'Core/hooks';
//Components
import { NotificationContainer } from "Components/Notifications";
import { NotificationManager } from 'Components/Notifications';
import { Modal, Button, IconButton, SearchInput } from "@gpstrackit/gtc-react-controls";
import { Grid } from '@mui/material';
import { defaultLocale } from 'Core/defaultValues';

import moment from 'moment';
//Actions
import {
    openModalDeleteDriverScheduledTaskRedux,
    openModalCompleteDriverScheduledTask,
    openModalScheduleDriverTasks
} from 'Redux/actions'
import {
    maintenanceMDTSSearchDriverScheduledTasks,
    reset,
} from './redux/slice';

//Styles
import './styles.scss';

const ManageDriverTasksScheduled = (props) => {
    const { refresh } = props;

    const dispatch = useDispatch();
    const { messages } = useIntl();

    //Redux States
    const {
        driverTasksScheduled,
        driverName,
        driverId,
        loading,
        error,
        open,
    } = useSelector(state => state.maintenanceManageDriverTasksScheduledRedux);
    const deleteReponse = useSelector(state => state.maintenanceDeleteDriverScheduledTaskRedux.response);
    const alertSubscriberResponse = useSelector(state => state.maintenanceScheduleDriverTasksRedux.alertSubscriberResponse);
    const responseScheduleDriverTasks = useSelector(state => state.maintenanceScheduleDriverTasksRedux.scheduleDriverTaskResult);
    const completeDriverScheduledTask = useSelector(state => state.maintenanceCompleteDriverScheduledTaskRedux.completeDriverScheduledTask);
    const driversList = useRealtimeDrivers({ trackFields: ['id', 'name', 'externalId', 'disabled', 'tags'] });

    const [search, setSearch] = useState('');

    const handleClose = () => {
        dispatch(reset());
        setSearch('')
    };

    useEffect(() => {
        if (open && deleteReponse || open && alertSubscriberResponse || open && responseScheduleDriverTasks || open && completeDriverScheduledTask?.id) {
            dispatch(maintenanceMDTSSearchDriverScheduledTasks({ openSearch: search, driverId }))
        }
    }, [deleteReponse, alertSubscriberResponse, responseScheduleDriverTasks, completeDriverScheduledTask])

    useEffect(() => {
        if (error) {
            NotificationManager.error(
                error?.error || messages['errorMessage'],
                messages['error'],
                3000,
                null,
                null,
                'error',
            );
            dispatch(reset({ error: null }));
        }
    }, [error])

    useEffect(() => {
        if (open && driverId) {
            dispatch(maintenanceMDTSSearchDriverScheduledTasks({ openSearch: search, driverId }))
        }
    }, [driverId])

    const getStatusName = (status, completed) => {
        if (completed) {
            return messages['manageDriverTasksScheduled_completed'];
        }
        let tooltip

        switch (status) {
            case "PastDue":
                tooltip = messages['manageDriverTasksScheduled_pastDue'];
                break
            case "Due":
                tooltip = messages['manageDriverTasksScheduled_dueStatus'];
                break
            case "DueSoon":
                tooltip = messages['manageDriverTasksScheduled_dueSoon'];
                break
            case "Scheduled":
                tooltip = messages['manageDriverTasksScheduled_scheduled'];
                break
            case "Done":
                tooltip = messages['manageDriverTasksScheduled_done'];
                break
        }
        return tooltip;
    }

    const getDate = (driver) => {
        let newDate = null;
        if (driver.status === "Done") newDate = moment(driver.lastMaintenanceDate);
        else newDate = moment(driver.dueDate);

        if (newDate.isValid()) {
            return `, ${newDate.locale(defaultLocale || "en").format('MMM DD, YYYY')}`;
        }
        return "";
    }

    const getClassItemContent = (status, completed) => {
        if (completed) {
            return `complete-item-container`;
        }
        return `${status}-item-container`;
    }

    const onSearchText = useCallback((newSearchText) => {
        setSearch(newSearchText);
        if (window.typingTime) {
            clearTimeout(window.typingTime);
        }
        window.typingTime = setTimeout(() => {
            dispatch(maintenanceMDTSSearchDriverScheduledTasks({ openSearch: newSearchText, driverId }))
        }, 500);
    });

    const renderItems = () => {
        return (
            <Fragment>
                {driverTasksScheduled && driverTasksScheduled.length ?
                    [...driverTasksScheduled].sort((a, b) => {

                        if (a.status != b.status) {
                            return a.status == "Done" && 1 || b.status == "Done" && -1 || new moment(a.dueDate).format('YYYYMMDD') - new moment(b.dueDate).format('YYYYMMDD')
                        }
                        else if (a.status == "Done" && b.status == "Done") {
                            return new moment(b.lastMaintenanceDate).format('YYYYMMDD') - new moment(a.lastMaintenanceDate).format('YYYYMMDD')
                        }
                        else {
                            return new moment(a.dueDate).format('YYYYMMDD') - new moment(b.dueDate).format('YYYYMMDD')
                        }
                    })
                        .map((driverTask, key) => {
                            return (
                                <Grid
                                    container
                                    direction="column"
                                    className={`manage-driver-tasks-item ${getClassItemContent(driverTask.status, driverTask.completed)}`}
                                    key={key}
                                >
                                    <div>
                                        <span className="manage-driver-tasks-title">{driverTask.driverTaskName}</span>
                                    </div>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        spacing={1}
                                    >
                                        <Grid item>
                                            <p className="manage-driver-tasks-name">
                                                {getStatusName(driverTask.status, driverTask.completed)} {getDate(driverTask)}
                                            </p>
                                        </Grid>
                                        <Grid item>
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="flex-end"
                                                alignItems="flex-end"
                                                spacing={1}
                                            >
                                                <Grid item>
                                                    <IconButton
                                                        icon={driverTask.completed ? 'check_circle' : 'check_circle_outline'}
                                                        tooltip={driverTask.completed ? messages['manageDriverTasksScheduled_completed'] : messages['manageDriverTasksScheduled_toComplete']}
                                                        style={{ color: !driverTask.completed ? 'white' : '' }}
                                                        isDisabled={driverTask.completed}
                                                        onClick={() => dispatch(openModalCompleteDriverScheduledTask({ open: true, tasks: driverTask, driverName: driverName }))}
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <IconButton
                                                        icon="history"
                                                        tooltip={messages['edit']}
                                                        style={{ color: !driverTask.completed ? 'white' : '' }}
                                                        isDisabled={driverTask.completed}
                                                        onClick={() => dispatch(openModalScheduleDriverTasks({ open: true, id: driverTask.id }))}
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <IconButton
                                                        icon="delete"
                                                        tooltip={messages['delete']}
                                                        style={{ color: !driverTask.completed ? 'white' : '' }}
                                                        isDisabled={driverTask.completed}
                                                        onClick={() => dispatch(openModalDeleteDriverScheduledTaskRedux({ open: true, tasks: driverTask, driverName: driverName }))}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            );
                        }) : <div style={{ display: 'flex', justifyContent: 'center', opacity: 0.5 }} ><span>{messages['manageDriverTasksScheduled_noTasks']}</span></div>}
            </Fragment>
        );
    };

    return (
        <Modal
            title={`${messages['manageDriverTasksScheduled_tile']} ${driverName}`}
            size="small"
            loading={loading}
            open={open}
            handleClose={handleClose}
            footer={(
                <div>
                    <Button
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleClose()}
                        isDisabled={loading}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={(e) => dispatch(openModalScheduleDriverTasks({ open: true, driverId: driverId }))}
                        isDisabled={loading || !driversList.find(d => d.driverId == driverId)}
                    >
                        {messages['manageDriverTasksScheduled_addNew']}
                    </Button>
                </div>
            )}
        >
            <div style={{ padding: '0px 25px' }}>
                <div style={{ margin: '15px 0' }}>
                    <SearchInput
                        searchText={search}
                        onSearchText={onSearchText}
                        placeholder={messages['search']}
                    />
                </div>
                {renderItems()}
            </div>
            <NotificationContainer />
        </Modal>
    )
}

export default ManageDriverTasksScheduled;
